<template>
  <div class="app-container">
    <!-- <div class="detailsTitle">
      <h4>盘库订单</h4>
    </div> -->
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="95px" size="mini" style="width: 100%;">
        <div class="formItemBox">
        <el-form-item label="盘库单号:">
          <el-input type="text" v-model="formData.inventoryNo"  size="mini" placeholder="请输入盘库单号"></el-input>
        </el-form-item>
        <el-form-item label="盘库状态:">
          <el-select v-model="formData.orderStatus" size="mini" placeholder="请选择盘库状态" filterable clearable>
            <el-option v-for="item in orderStatusData" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建人:">
          <el-input v-model="formData.createUser" size="mini" placeholder="请输入创建人"></el-input>
        </el-form-item>
        <el-form-item label="盘库人:">
          <el-select v-model="formData.inventoryPerson" size="mini" placeholder="请选择盘库人" filterable clearable>
            <el-option v-for="item in pankurenData" :key="item.userName" :label="item.userName" :value="item.userName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间:">
          <div style="display: flex;">
          <el-date-picker v-model="formData.createTimeStart" size="mini" type="datetime" placeholder="请选择创建时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
          -
          <el-date-picker v-model="formData.createTimeEnd" size="mini" placeholder="请选择创建时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="盘库类型:">
          <el-select v-model="formData.inventoryType" size="mini" placeholder="请选择盘库类型" filterable clearable>
            <el-option v-for="(item, index) in pkTypeData" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
       </div>
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[1]">重置</el-button>
          <el-button type="primary" size="mini" @click="xinjian" v-if="btnFlg[2]">新建盘库</el-button>
          <el-button type="primary" size="mini" @click="daoruJb" v-if="btnFlg[3]">导入卷板货物</el-button>
          <el-button type="primary" size="mini" @click="daoruJc" v-if="btnFlg[4]">导入建材货物</el-button>
          <el-button type="primary" size="mini" @click="shanchu" v-if="btnFlg[5]">删除</el-button>
          <el-button type="primary" size="mini" @click="panhuo" v-if="btnFlg[6]">盘库完成</el-button>
          <el-button type="primary" size="mini" @click="xiazai" v-if="btnFlg[7]">下载模板</el-button>
          <el-button type="primary" size="mini" @click="sendMessage" v-if="btnFlg[8]">发短信通知</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row @row-click="dianjixuanzhong" @selection-change="selectGoods" class="tableComent">
        <el-table-column type="selection" align="center" width="60"></el-table-column>
        <el-table-column fixed type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column fixed width="150" label="操作" align="center">
          <template v-slot='scope'>
            <el-button type="text" @click="HWclick(scope.$index,scope.row)">货物</el-button>
            <el-button type="text" @click="RYclick(scope.$index,scope.row)">人员</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="orderStatus" label="盘库状态" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryNo" label="盘库单号" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryType" label="盘库类型" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allnumber" label="总件数" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="remark" label="任务描述" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" width="120" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryPerson" label="盘库人" width="120" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryTimeStart" label="盘库开始时间" width="180" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inventoryTimeEnd" label="盘库结束时间" width="180" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <el-dialog title="盘库完成" v-if="pankuFinish" :visible.sync="pankuFinish" width="35%" center :before-close="closepanku">
      <el-form style="width:50%;margin:0 auto;" :model="pankuFinishForm" class="demo-form-inline" ref="formData">
        <el-form-item label="订单来源:">
          <div>{{pankuFinishForm.orderSource}}</div>
        </el-form-item>
        <el-form-item label="盘库客户:">
          <div>{{pankuFinishForm.customerName}}</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="FinishOk">确定</el-button>
        <el-button type="primary" @click="closepanku">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="新建盘库" v-if="pankuAdd" :visible.sync="pankuAdd" width="30%" center :before-close="closePankuAdd">
      <el-form style="width:70%;margin:0 auto;" :model="pankuAddForm" class="demo-form-inline" ref="addFormData" :rules="pankuRules" label-width="120px">
        <el-form-item label="仓库名称：" prop="organizationName">
          <el-input style="width:200px" type="text" v-model="pankuAddForm.organizationName" size="mini" placeholder="请输入仓库名称"></el-input>
        </el-form-item>
        <el-form-item label="盘库人：" prop="inventoryPerson">
          <el-select style="width:200px" v-model="pankuAddForm.inventoryPerson" size="mini" placeholder="请选择盘库状态" filterable clearable>
            <el-option v-for="item in pankurenData" :key="item.userName" :label="item.userName" :value="item.userName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="盘库类型：" prop="inventoryType">
          <el-select style="width:200px" v-model="pankuAddForm.inventoryType" size="mini" placeholder="请选择盘库类型" filterable clearable>
            <el-option v-for="item in pkTypeData" :key="item.name" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务描述：" prop="remark">
          <el-input show-word-limit style="width:200px" type="textarea" v-model="pankuAddForm.remark" size="mini" placeholder="请输入任务描述：" :maxlength="200" :rows="7"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" :loading="xinzengLoad" @click="xinjianok">确定</el-button>
        <el-button type="primary" @click="closePankuAdd">取消</el-button>
      </div>
    </el-dialog>
    <!--点击导入按钮弹出框-->
    <div class="addMarkBox" custom-class="el-dialog--center">
      <el-dialog :before-close="closeDialogFile" title="导入" :visible.sync="daoruMark" :close-on-click-modal="false" width="40%" center>
        <div style="margin: 15px auto" class="el-dialog--center">
          <input type="file" ref="file" accept=".xls, .xlsx" @change="getFile($event)" />
        </div>
        <div style="margin: 15px auto" class="el-dialog--center">
          <el-button @click="closeDialogFile">取消</el-button>
          <el-button type="primary" @click="daoruQueding()" :disabled="isDisable1">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import {
  getRelationCustomer,
  getJGInventoryOrderList,
  deleteJGInventoryList,
  JGfinishInventoryList,
  pankuren,
  importJBInventoryGoods,
  importJCInventoryGoods,
  addNewInventoryList
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn } from '@/utils/getButton'
import { encryption } from '@/utils/util'

export default {
  components: {},

  data () {
    return {
      formData: {
        inventoryNo: '',
        orderStatus: '',
        createTimeStart: '',
        createTimeEnd: '',
        createUser: '',
        inventoryPerson: '',
        inventoryType: ''
      },
      RKData: [],
      orderStatusData: [
        {
          id: 0,
          name: '待盘库'
        },
        {
          id: 1,
          name: '盘库中'
        },
        {
          id: 2,
          name: '已结束'
        }
      ],
      h: '500px',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      btnArr: [
        '0130070100',
        '0130070200',
        '0130070300',
        '0130070400',
        '0130070500',
        '0130070600',
        '0130070700',
        '0130070800',
        '0130070900'
      ],
      btnFlg: [],
      xuanzhongArr: null,
      selectList: [],

      zhangdanDetailVisible: false,
      inventoryMasterId: '',
      pankuFinish: false,
      pankuFinishForm: {
        customerName: '',
        orderSource: ''
      },
      pkTypeData: [
        {
          name: '建材'
        },
        {
          name: '卷板'
        }
      ],
      pankuAdd: false,
      pankurenData: [],
      pankuAddForm: {
        organizationName: '',
        inventoryPerson: '',
        inventoryType: '',
        remark: ''
      },
      pankuRules: {
        organizationName: [{ required: true, message: '请输入仓库名称', trigger: 'change' }],
        inventoryPerson: [{ required: true, message: '请选择盘库人', trigger: 'change' }],
        inventoryType: [{ required: true, message: '请选择盘库类型', trigger: 'change' }]
      },
      daoruMark: false,
      type: '',
      isDisable1: false,
      xinzengLoad: false,
      mobile: '17835698180'
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 155 + 'px'
    this.getRelationCustomerS()
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/jianguanInventoryOrder')
    this.chaxun()
    this.pankuren()
  },
  methods: {
    closeDialogFile () {
      this.file = null
      this.$refs.file.value = ''
      this.daoruMark = false
    },
    getFile: function (event) {
      this.file = event.target.files[0]
    },
    // 导入-确定
    daoruQueding (event) {
      function extname (filename) {
        if (!filename || typeof filename != 'string') {
          return false
        }
        let a = filename.split('').reverse().join('')
        let b = a.substring(0, a.search(/\./)).split('').reverse().join('')
        return b
      }
      if (!this.file) {
        this.$message.error('请选择文件')
        return
      }
      let name = extname(this.file.name)
      if (name == false) {
        this.$alert('文件为空,请选择文件进行导入', '系统提示')
      } else if (name != 'xlsx' && name != 'csv' && name != 'xls') {
        this.$alert('请选择正确的文件格式', '系统提示')
      } else {
        let formData = new FormData()
        formData.append('file', this.file)
        formData.append('inventoryMasterId', this.selectList[0].inventoryMasterId)
        this.isDisable1 = true
        if (this.type == 'jb') {
          importJBInventoryGoods(formData)
            .then((res) => {
              // -1 提示错误信息， 0 成功， 1显示导出异常
              this.daoruMark = false
              this.isDisable1 = false
              this.$message({
                message: res,
                type: 'success'
              })
              this.chaxun()
            })
            .catch((err) => {
              if (err.code == -1) {
                this.$message({
                  message: err.data == null ? err.message : err.data,
                  type: 'error'
                })
              }
              this.isDisable1 = false
            })
        } else {
          importJCInventoryGoods(formData)
            .then((res) => {
              // -1 提示错误信息， 0 成功， 1显示导出异常
              this.daoruMark = false
              this.isDisable1 = false
              this.$message({
                message: res,
                type: 'success'
              })
              this.chaxun()
            })
            .catch((err) => {
              if (err.code == -1) {
                this.$message({
                  message: err.data == null ? err.message : err.data,
                  type: 'error'
                })
              }
              this.isDisable1 = false
            })
        }
      }
    },
    closePankuAdd () {
      this.pankuAdd = false
    },
    xiazai () {
      window.open(
        'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/wms/ExcelModel/%E7%9B%98%E5%BA%93%E8%B4%A7%E7%89%A9%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.zip'
      )
    },
    sendMessage () {
      if (this.selectList.length == 0) {
        this.$message.error('请选择需要发送短信数据')
      } else {
        for (let i = 0; i < this.selectList.length; i++) {
          let Authorization1 = encryption({
            data: { Basic: this.global.headerBasic },
            type: 'Base64',
            param: ['Basic']
          })
          this.$axios({
            headers: {
              Authorization: 'Basic ' + Authorization1.Basic
            },
            method: 'post',
            url: this.global.wmsStockName + '/inventory/InventorySendSMS',
            params: {
              mobile: this.selectList[i].telephone,
              tplId: '246252'
            },
            data: {
              inventoryMasterId: this.selectList[i].inventoryMasterId
            }
          }).then(res => {
            console.log(res)
            if (res.code == 0) {
              this.$message.success('发送成功请注意查收')
            } else {
              this.$message.error(res.message)
            }
          }).catch(error => {
            console.log('错误', error)
            this.$message.error(error.message)
          })
        }
      }
    },
    daoruJb () {
      let hasStart = this.selectList[0].orderStatus != '待盘库'

      if (this.selectList.length == 0) {
        this.$message.error('请选择需要导入的数据')
      } else if (this.selectList.length != 1) {
        this.$message.error('请选择一条数据')
      } else if (hasStart) {
        this.$message.error('已执行任务单不可导入货物')
      } else if (this.selectList[0].inventoryType == '建材') {
        this.$message.error('只能选择卷板执行单导入')
      } else {
        this.daoruMark = true
        this.file = null
        this.type = 'jb'
        setTimeout(() => {
          this.$refs.file.value = ''
        }, 0)
      }
    },
    daoruJc () {
      let hasStart = this.selectList[0].orderStatus != '待盘库'
      if (this.selectList.length == 0) {
        this.$message.error('请选择需要导入的数据')
      } else if (this.selectList.length != 1) {
        this.$message.error('请选择一条数据')
      } else if (hasStart) {
        this.$message.error('已执行任务单不可导入货物')
      } else if (this.selectList[0].inventoryType == '卷板') {
        this.$message.error('只能选择建材执行单导入')
      } else {
        this.daoruMark = true
        this.file = null
        this.type = 'jc'
        setTimeout(() => {
          this.$refs.file.value = ''
        }, 0)
      }
    },
    xinjian () {
      this.pankuAddForm = {
        organizationName: '',
        inventoryPerson: '',
        inventoryType: '',
        remark: ''
      }
      this.pankuAdd = true
    },
    xinjianok () {
      this.$refs.addFormData.validate(valid => {
        if (valid) {
          this.xinzengLoad = true
          this.pankuAddForm.telephone = this.pankurenData.filter(item => item.userName == this.pankuAddForm.inventoryPerson)[0].mobile
          this.pankuAddForm.inventoryPersonId = this.pankurenData.filter(item => item.userName == this.pankuAddForm.inventoryPerson)[0].userCode
          addNewInventoryList(this.pankuAddForm)
            .then(res => {
              console.log(res)
              this.xinzengLoad = false
              this.pankuAdd = false
              this.chaxun()
            })
            .catch(err => {
              this.xinzengLoad = false
              this.$message({ message: err.message, type: 'error' })
            })
        }
      })
    },
    closepanku () {
      this.pankuFinish = false
    },
    FinishOk () {
      this.$confirm('是否确定盘货完成？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      }).then(res => {
        console.log(res)
        JGfinishInventoryList({
          inventoryMasterId: this.selectList[0].inventoryMasterId
        }).then(res => {
          console.log(res)
          this.$message.success('盘货完成')
          this.pankuFinish = false
          this.chaxun()
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    getJGInventoryOrderList () {
      getJGInventoryOrderList({
        ...this.formData,
        ...this.pageInfo
      }).then(res => {
        console.log(res)
        this.tableData = res.list
        this.total = res.total
      })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxun () {
      this.getJGInventoryOrderList()
    },
    chongzhi () {
      this.formData = {}
      this.chaxun()
    },
    shanchu () {
      let hasStart = this.selectList.some(item => item.orderStatus != '待盘库')
      if (this.selectList.length == 0) {
        this.$message.error('请选择需要删除的数据')
      } else if (hasStart) {
        this.$message.error('不可删除已执行的任务单')
      } else {
        this.$confirm('是否确定删除？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          closeOnClickModal: false,
          type: 'warning'
        }).then(res => {
          console.log(res)
          deleteJGInventoryList({
            inventoryMasterIds: this.selectList.map(item => item.inventoryMasterId).join(',')
          }).then(res => {
            console.log(res)
            this.$message.success('删除成功')
            this.chaxun()
          })
            .catch(error => {
              DonMessage.error(error.message)
            })
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      }
    },
    panhuo () {
      if (this.selectList.length == 0) {
        this.$message.error('请选择需要盘货的数据')
      } else if (this.selectList.length > 1) {
        this.$message.error('请选择一条数据操作')
      } else {
        this.$confirm('盘库完成后，此项业务结束，数据不再变化！', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          JGfinishInventoryList({
            inventoryMasterId: this.selectList[0].inventoryMasterId
          }).then(res => {
            console.log(res)
            this.$message.success('盘货完成')
            this.pankuFinish = false
            this.chaxun()
          })
            .catch(error => {
              DonMessage.error(error.message)
            })
        }).catch(() => {
        })
        // this.pankuFinishForm.orderSource = this.selectList[0].orderSource
        // this.pankuFinishForm.customerName = this.selectList[0].customerName
        // this.pankuFinish = true
      }
    },
    // 选中
    selectGoods (selection) {
      this.selectList = selection
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.$refs.tabref1.toggleRowSelection(row)
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 导出
    exportClick () {
      exportExcel(
        this.global.wmsStockName + '/inventory/exportInventoryOrderList',
        this.formData,
        '盘库订单信息表'
      )
    },
    // 提价panku
    tijiao () { },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    HWclick (index, row) {
      if (row.inventoryType == '建材') {
        this.$router.push({
          name: 'jianguancargoJC',
          query: {
            inventoryMasterId: row.inventoryMasterId
          }
        })
      } else {
        this.$router.push({
          name: 'jianguanCargo',
          query: {
            inventoryMasterId: row.inventoryMasterId,
            finished: row.orderStatus == '已结束' ? 1 : 0
          }
        })
      }
    },
    RYclick (index, row) {
      this.$router.push({
        name: 'jianguanPeople',
        query: {
          inventoryMasterId: row.inventoryMasterId
        }
      })
    },
    FYclick (index, row) {
      this.zhangdanDetailVisible = true
      this.inventoryMasterId = String(row.inventoryMasterId)
    },
    addJB (btnId) {
      this.$router.push({
        name: 'addJB',
        query: {
          menuOrBtnId: btnId
        }
      })
    },
    addJC (btnId) {
      this.$router.push({
        name: 'addJC',
        query: {
          menuOrBtnId: btnId
        }
      })
    },
    pankuren () {
      pankuren({
        tenantCode: localStorage.getItem('tenantCode'),
        useTenantCode: localStorage.getItem('tenantCode'),
        flag: '1'
      }).then(res => {
        console.log(res)
        this.pankurenData = res
      })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    }
  }

}
</script>

<style lang='less' scoped>
/deep/.el-textarea .el-input__count {
  bottom: auto !important;
}
.messages {
  font-size: 16px;
}
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
